export enum FetchHeader {
  X_APP_CLIENT_SESSION_ID = "X-App-Client-Session-Id",
}
